module.exports = __webpack_public_path__ + "img/工商银行@2x.5670df5d.png";